import { render, staticRenderFns } from "./Component.Assignees.vue?vue&type=template&id=a1dbb6b8&"
import script from "./Component.Assignees.vue?vue&type=script&lang=js&"
export * from "./Component.Assignees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports